import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  PostApiDocumentMutationRequest,
  PostApiDocumentMutationResponse,
  PostApiDocument401,
  PostApiDocument403,
} from "../../../types/PostApiDocument";

export function getPostApiDocumentUrl() {
  return `/api/Document` as const;
}

/**
 * {@link /api/Document}
 */
export async function postApiDocument(
  data?: PostApiDocumentMutationRequest,
  config: Partial<RequestConfig<PostApiDocumentMutationRequest>> & {
    client?: typeof client;
  } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const formData = new FormData();
  if (data) {
    Object.keys(data).forEach((key) => {
      const value = data[key as keyof typeof data];
      if (
        typeof key === "string" &&
        (typeof value === "string" || value instanceof Blob)
      ) {
        formData.append(key, value);
      }
    });
  }
  const res = await request<
    PostApiDocumentMutationResponse,
    ResponseErrorConfig<PostApiDocument401 | PostApiDocument403>,
    PostApiDocumentMutationRequest
  >({
    method: "POST",
    url: getPostApiDocumentUrl().toString(),
    data: formData,
    ...requestConfig,
    headers: {
      "Content-Type": "multipart/form-data",
      ...requestConfig.headers,
    },
  });
  return res;
}
